import {
  GOICUOC5G_COUNT_ASSIGN_SUCCESS,
  GOICUOC5G_HISTORY_LIST_SUCCESS,
  GOICUOC5G_IMPORT_SUCCESS,
  GOICUOC5G_LIST_SUCCESS,
  GOICUOC5G_NEW_CARE_SUCCESS,
  GOICUOC5G_ONE_SUCCESS,
  GOICUOC5G_UPDATE_FILTER,

  GOICUOC5G_UPDATE_HOMEPAGE_FILTER,
  GOICUOC5G_HOMEPAGE_LIST_SUCCESS,
  GOICUOC5G_HOMEPAGE_ONE_SUCCESS,

  GOICUOC5G_LIMIT_UPDATE_HOMEPAGE_FILTER,
  GOICUOC5G_LIMIT_HOMEPAGE_LIST_SUCCESS,
  GOICUOC5G_LIMIT_HOMEPAGE_ONE_SUCCESS,

  GOICUOC5G_HANDLE_IMPORT_ERRORS,
} from 'src/actions/goicuoc5g.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageGoicuoc5gFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageGoicuoc5gPage: 0,
    homepageGoicuoc5gLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageGoicuoc5gLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageGoicuoc5gLimitPage: 0,
    homepageGoicuoc5gLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,

  homepageGoicuoc5gItems: [],
  homepageGoicuoc5gTotal: 0,
  homepageGoicuoc5gSelected: undefined,

  homepageGoicuoc5gLimitItems: [],
  homepageGoicuoc5gLimitTotal: 0,
  homepageGoicuoc5gLimitSelected: undefined,

  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  errorRows: {},
}

const goicuoc5gReducer = (state = initState, action) => {
  switch (action.type) {
    case GOICUOC5G_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case GOICUOC5G_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case GOICUOC5G_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case GOICUOC5G_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageGoicuoc5gFilter !== 'undefined' && state.homepageGoicuoc5gFilter) {
        if (action.data.homepageGoicuoc5gPage == 'no_update' && typeof state.homepageGoicuoc5gFilter.homepageGoicuoc5gPage !== 'undefined') action.data.homepageGoicuoc5gPage = state.homepageGoicuoc5gFilter.homepageGoicuoc5gPage;
        if (action.data.homepageGoicuoc5gLimit == 'no_update' && typeof state.homepageGoicuoc5gFilter.homepageGoicuoc5gLimit !== 'undefined') action.data.homepageGoicuoc5gLimit = state.homepageGoicuoc5gFilter.homepageGoicuoc5gLimit;
      }
      return {
        ...state,
        homepageGoicuoc5gFilter: action.data,
      }
    }
    case GOICUOC5G_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageGoicuoc5gItems: action.data.homepageGoicuoc5gItems,
        homepageGoicuoc5gTotal: action.data.homepageGoicuoc5gTotal,
      }
    }
    case GOICUOC5G_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageGoicuoc5gSelected: action.data
      }
    }
    case GOICUOC5G_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageGoicuoc5gLimitFilter !== 'undefined' && state.homepageGoicuoc5gLimitFilter) {
        if (action.data.homepageGoicuoc5gLimitPage == 'no_update' && typeof state.homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitPage !== 'undefined') action.data.homepageGoicuoc5gLimitPage = state.homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitPage;
        if (action.data.homepageGoicuoc5gLimitLimit == 'no_update' && typeof state.homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitLimit !== 'undefined') action.data.homepageGoicuoc5gLimitLimit = state.homepageGoicuoc5gLimitFilter.homepageGoicuoc5gLimitLimit;
      }
      return {
        ...state,
        homepageGoicuoc5gLimitFilter: action.data,
      }
    }
    case GOICUOC5G_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageGoicuoc5gLimitItems: action.data.homepageGoicuoc5gLimitItems,
        homepageGoicuoc5gLimitTotal: action.data.homepageGoicuoc5gLimitTotal,
      }
    }
    case GOICUOC5G_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageGoicuoc5gLimitSelected: action.data
      }
    }
    case GOICUOC5G_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case GOICUOC5G_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case GOICUOC5G_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case GOICUOC5G_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case GOICUOC5G_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default goicuoc5gReducer